// extracted by mini-css-extract-plugin
module.exports = {"icon":"CustomIcon_icon__ujr_M","noFill":"CustomIcon_noFill__L8GcV"};